import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { LegalHubPage } from "./legal.index";

export const Route = createFileRoute("/vi/legal/")({
  head: () => ({
    meta: [
      { title: "Trung tâm Pháp lý — Banana Cards" },
      { name: "description", content: "Tất cả tài liệu pháp lý, tuân thủ và đối tác của Banana Cards." },
    ],
    links: alternateLinkList("/legal", "vi"),
  }),
  component: LegalHubPage,
});